
function getApiBaseUrl() {
  // 1) если задано переменной окружения — используем (удобно для dev/prod)
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) return envUrl.replace(/\/+$/, ""); // убираем / на конце

  // 2) иначе строим из текущего домена (tenant уже в домене)
  const { protocol, hostname } = window.location;

  // DEV-случай: фронт на :3000, бэк на :8000
  // будет: http://test.localhost:8000
  return `${protocol}//${hostname}:8000`;
}

const appConfig = {
  API_BASE_URL: getApiBaseUrl(),

  // ✅ настройки сессии (вариант A)
  SESSION_WARNING_MS: 30_000,      // показать модалку за 30 сек до “конца”
  SESSION_EXTEND_BY_MS: 30 * 60_000, // продлить на 2 минуты
  SITE_KEY: "0x4AAAAAAC8i3fcpNsmdNhUG",
  DEMO_PATH: "https://demo.velsoftcrm.com/employee-register",

  // ✅ путь логина (у тебя логин на "/")
  LOGIN_PATH: "/",
};

export default appConfig;
